import theme from '../../../lib/theme';
import { StoryAuthorProps } from './StoryAuthor';

const nameSizes: any = {
  s: 'm',
  m: 'l',
  l: 'xl',
  xl: 'xxxl',
};

const titleSizes: any = {
  s: 's',
  m: 's',
  xl: 'm',
};

const taglineSizes: any = {
  s: 'm',
  m: 'm',
  xl: 'l',
};

const rowGaps = {
  m: 'xs',
  l: 's',
  xl: 's',
};

const {
  colors,
  media,
  layouts,
  font: {
    heights,
    spacings,
    families,

    ...font
  },
} = theme;

export default ({ vane = false, size = 'm' }: StoryAuthorProps) => ({
  link: {
    textDecoration: 'none',

    '&:hover': {
      color: colors.sas.primary,
      textDecoration: 'none !important',
    },

    '&:hover *': {
      color: colors.sas.primary,
    },

    '&:hover .StoryAuthor__name': {
      textDecoration: 'underline',
    },
  },

  author: {
    ...layouts.spacedRow(rowGaps[size] || rowGaps.m),

    fontFamily: families.primary,
    fontSize: font.s,
    fontWeight: font.normal,
    letterSpacing: spacings.m,
    lineHeight: 1,
    textDecoration: 'none',
  },

  authorTitle: {
    textTransform: 'uppercase',
    letterSpacing: spacings.m,
    color: vane ? colors.dark_grey : colors.black,
    whiteSpace: 'nowrap',
    fontSize: font[size === 's' ? titleSizes.s : titleSizes.m],

    [media.s.up]: {
      fontSize: font[titleSizes[size]],
    },
  },

  authorName: {
    fontFamily: families.primary,
    fontWeight: font.bold,
    color: colors.black,
    transition: 'all 150ms linear',
    fontSize: size === 's' ? nameSizes.s : nameSizes.m,

    [media.s.up]: {
      fontSize: font[nameSizes[size]],
    },
  },

  authorTagline: {
    fontFamily: families.primary,
    color: vane ? colors.dark_grey : colors.black,
    fontSize: font[size === 's' ? taglineSizes.s : taglineSizes.m],

    [media.s.up]: {
      fontSize: font[taglineSizes[size]],
    },
  },

  text: {
    ...layouts.spacedColumn('xxs'),

    alignItems: 'flex-start',
  },
});
